import { fetchWithAuth } from './fetchWithAuth'

export async function updateConfig(
  token: string,
  id: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth(`/v1/tenant-configs/${id}`, token, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}
